import { exportsModule } from '@cian/mf-registry/browser';
import { createMicrofrontendUI } from '../createMicrofrontendUI';
import { createApplicationState } from '../applicationState';
import { createApplicationContext } from '../applicationContext';
import { PUBLIC_RUNTIME_NAME, RUNTIME_NAME } from 'shared/constants/constants';
import { buildAPIRuntime } from './api';

export function runApp() {
  const context = createApplicationContext();
  const store = createApplicationState(context);

  exportsModule({
    // Рантайм ищется по имени ручки, которая отдала манифест, поэтому регистрируем оба
    // варианта: приватный для SSR и публичный для догрузки при SPA-переходе.
    ui: {
      [RUNTIME_NAME]: createMicrofrontendUI(context, store, RUNTIME_NAME),
      [PUBLIC_RUNTIME_NAME]: createMicrofrontendUI(context, store, PUBLIC_RUNTIME_NAME),
    },
    api: () => buildAPIRuntime(store),
  });
}
